import { AxiosRequestConfig } from 'axios'

const addArticleToFavorite = (
  type: string,
  id: string
): AxiosRequestConfig => ({
  url: `/${type}/favorite/add`,
  method: 'POST',
  params: {
    id
  }
})

export { addArticleToFavorite }
